/* eslint-disable @typescript-eslint/no-explicit-any */
import { atgOrigin } from '../../utilities/util';

interface SessionConfirmationResponse {
  sessionConfirmationNumber: string;
}

const getSessionConfirmationNumber = async (window: Window): Promise<SessionConfirmationResponse> => {
  try {
    const response = await fetch(
      `${atgOrigin(window)}/rest/model/atg/rest/SessionConfirmationActor/getSessionConfirmationNumber`,
      { method: 'POST' },
    );

    const data = (await response.json()) as SessionConfirmationResponse;

    return data;
  } catch {
    throw new Error('Could not retrieve session confirmation number');
  }
};

export default getSessionConfirmationNumber;
